<div class="progress-meter-wrapper">
  <div class="progress-meter-container">
    <div
        *ngFor="let step of steps; let index = index"
        [ngClass]="{ 'last-step': index === steps.length - 1 }"
        class="progress-meter-step-container"
    >
      <div class="progress-step-item" [ngClass]="{'in-progress': currentStepIndex === step.index}">
        <div class="progress-step-ball" [ngClass]="{'progress-step-complete': step.state === 'COMPLETE', 'step-in-progress': step.state === 'IN_PROGRESS'}">
        </div>
        <div *ngIf="step.state === 'IN_PROGRESS'" class="spinner"></div>
        <div class="progress-step-label" [ngClass]="{'step-in-progress': step.state === 'IN_PROGRESS'}">{{ step.label }}</div>
      </div>
      <div *ngIf="index !== steps.length - 1">
        <div class="progress-step-bar"
             [ngClass]="{
              'progress-step-complete': getProgressBarStyle(index),
              'step-in-progress': currentStepIndex === index + 1
            }"
        >
        </div>
      </div>
    </div>
  </div>
</div>
